export const ITEMS_QUERY_KEYS = {
  bookmarks: 'bookmarks-items',
  companies: {
    items: 'companies-items',
    jobs: {
      items: (id) => `company-jobs-items-${id}`,
      pinnedItems: (id) => `company-jobs-pinned-items-${id}`,
    },
    people: {
      current: (id) => `companies-current-users-${id}`,
      past: (id) => `companies-past-users-${id}`,
    },
  },
  donations: {
    tags: 'donations-tags',
    items: 'donations-items',
  },
  forum: {
    tags: 'forum-tags',
    items: 'forum-items',
    pinnedItems: 'forum-pinned-item',
    side: 'forum-widgets',
  },
  jobs: {
    tags: 'jobs-tags',
    items: 'jobs-items',
    pinnedItems: 'jobs-pinned-items',
  },
  mediacenter: {
    files: 'mediacenter-files-items',
    folders: 'mediacenter-folders-items',
  },
  news: {
    tags: 'news-tags',
    items: 'news-items',
    pinnedItems: 'news-slider-items',
  },
  notifications: 'notifications-items',
  portfolios: 'portfolios-items',
  projects: 'projects-items',
  mentoring: {
    // @TODO do not use function for keys but rather useQuery(['mentoring-items', id])
    // or useQuery([ITEMS_QUERY_KEYS.mentoring.items, id])  ITEMS_QUERY_KEYS
    items: (id) => `mentoring-items-${id}`,
  },
  myMentoring: {
    items: 'my-mentoring-items',
    mentors: (id) => `mentoring-mentors-${id}`,
    mentees: (id) => `mentoring-mentees-${id}`,
  },
} as const;

export const getNextCursorPageParam = (lastPage) =>
  lastPage.hasNextPage ? lastPage.endCursor : undefined;

export const getNextPageParam = (lastPage, pages) => {
  const totalItems = lastPage?.totalItems ?? 0;

  if (!lastPage || totalItems === 0) {
    return;
  }

  const currentTotalItems = pages.reduce(
    // In some cases items can be undefined. See https://hivebrite.atlassian.net/browse/PS-11813
    (acc, page) => acc + (page?.items?.length ?? 0),
    0,
  );

  return currentTotalItems < totalItems ? pages.length + 1 : undefined;
};
